/**
 * Sphinx host context — the inspector's own house chrome.
 *
 * The style-variable maps + `getSphinxStyleVariables` now live in the SDK
 * (`@sphinx/sdk/host-config/templates`) so the host-template seeds can run in
 * Node (the server `--template` resolver). They are re-exported here so the
 * client importers (`client-styles/built-ins.ts`) keep one import path and
 * there is a single source of truth. `SPHINX_CHAT_BACKGROUND` stays local — it
 * is chat-shell chrome, not part of host-config seeding.
 *
 * Values mirror `design-system/src/tokens.css` (the `@sphinx/design-system`
 * package consumed by `client/src/index.css`).
 */

import type { McpUiStyles } from "@modelcontextprotocol/ext-apps/app-bridge";
import { getSphinxStyleVariables as sdkGetSphinxStyleVariables } from "@sphinx/sdk/host-config/templates";

export {
  SPHINX_PLATFORM,
  SPHINX_FONT_CSS,
} from "@sphinx/sdk/host-config/templates";

// The SDK fn types its return as `Record<string, string>` (no McpUiStyles dep);
// re-assert the `McpUiStyles` return the inspector's host-style registry
// expects. The two are structurally the same CSS-variable map.
export const getSphinxStyleVariables = sdkGetSphinxStyleVariables as (
  theme: "light" | "dark",
) => McpUiStyles;

/**
 * Chat-surface background. Mirrors design-system `--background` exactly
 * — the warm cream `oklch(0.9818 0.0054 95.0986)` in light and the warm
 * deep brown `oklch(0.2679 0.0036 106.6427)` in dark.
 */
export const SPHINX_CHAT_BACKGROUND = {
  light: "oklch(0.9818 0.0054 95.0986)",
  dark: "oklch(0.2679 0.0036 106.6427)",
};
